<div class="d-flex">

  <div class="me-2">
    <span i18n>Stupeň štúdia</span> -
    <span>{{vybraneStupneStudiaString}}</span>
    <button mat-mini-fab color="primary" class="m-2" [disabled]="disabled"
      type="button"
      (click)="openStupneStudiaDialog()"
      [matTooltip]="'Vybrať stupne štúdia' | translate">
      <mat-icon>playlist_add</mat-icon>
      <!-- <mat-icon>library_add</mat-icon> -->
    </button>
  </div>

  <div>
    <span i18n>Typ štúdia</span> -
    <span>{{vybraneTypyStudiaString}}</span>
    <button mat-mini-fab color="primary" class="m-2" [disabled]="disabled"
      type="button"
      (click)="openTypyStudiaDialog()"
      [matTooltip]="'Vybrať typy štúdia' | translate">
      <mat-icon>playlist_add</mat-icon>
      <!-- <mat-icon>library_add</mat-icon> -->
    </button>
  </div>

</div>
